// Small, token-driven UI primitives shared by every renderer. Styling lives in
// tokens.css (mirroring the desktop palette); these components just apply the
// classes so screens stay consistent and parity is a deliberate match.

import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "success" | "danger";

export function Button({
  variant = "primary",
  ...props
}: { variant?: Variant } & ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button className={`jol-btn jol-btn--${variant}`} {...props} />;
}

export function Screen({ children }: { children: ReactNode }) {
  return <main className="jol-screen">{children}</main>;
}

export function Card({ children }: { children: ReactNode }) {
  return <div className="jol-card">{children}</div>;
}

export function Message({ title, body }: { title: string; body?: string }) {
  return (
    <Card>
      <div className="jol-center">
        <h1 className="jol-title">{title}</h1>
        {body ? <p className="jol-body">{body}</p> : null}
      </div>
    </Card>
  );
}

export function Loading({ message }: { message: string }) {
  return (
    <Card>
      <div className="jol-center">
        <p className="jol-body">{message}</p>
        <div className="jol-spinner" role="status" aria-label="Loading" />
      </div>
    </Card>
  );
}
